export function listPageSize (option = {}) {
  return [10, 20, 50, 100].includes(Number(option.pageSize)) ? Number(option.pageSize) : 20
}

export function listKeyword (value) { return String(value || '').trim().slice(0, 100) }

export function filterListRows (rows, keyword) {
  const needle = listKeyword(keyword).toLocaleLowerCase()
  return needle ? rows.filter(row => [row.name, row.id].some(value => String(value || '').toLocaleLowerCase().includes(needle))) : rows
}

// 使用实际行高，在还剩约两行时预取；不受外层画布 transform 缩放影响。
export function nearListEnd (body, rowHeight = 68) {
  if (!body || body.clientHeight <= 0) return false
  const rows = Array.from(body.querySelectorAll('.screen-fleet-list__row')).slice(-2)
  const threshold = rows.length ? rows.reduce((sum, row) => sum + row.offsetHeight, 0) : rowHeight * 2
  return body.scrollHeight - body.scrollTop - body.clientHeight <= Math.max(1, threshold)
}

export function appendListRows (previous, next) {
  const ids = new Set(previous.map(row => row.id))
  return previous.concat(next.filter(row => !ids.has(row.id)))
}
